// Admin-Panel: kleine Hooks und Hilfen (Entprellen, 403-Erkennung, Kontext für „Kein Zugriff").
import { createContext, useContext, useEffect, useState } from 'react';
import { ApiError } from '../../../lib/api';

/** Wert verzögert übernehmen (Suche). */
export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

export function isForbidden(err: unknown): boolean {
  return err instanceof ApiError && err.status === 403;
}

/** AdminPanel stellt `report` bereit; Seiten melden darüber 403-Antworten → Kein-Zugriff-Anzeige. */
export const AdminForbiddenContext = createContext<() => void>(() => {});

/** Meldet einen 403-Fehler an das Panel. */
export function useReportForbidden(error: unknown): void {
  const report = useContext(AdminForbiddenContext);
  const forbidden = isForbidden(error);
  useEffect(() => {
    if (forbidden) report();
  }, [forbidden, report]);
}

/** Nutzer-Löschen: 409 → verständliche Meldung. */
export function deleteUserErrorText(err: unknown): string | null {
  if (err instanceof ApiError && err.status === 409) {
    return 'Der Nutzer besitzt noch Server. Übertrage oder lösche diese Server zuerst (Bereich „Server").';
  }
  return null;
}

export const USERNAME_RE = /^[a-z0-9_.]{2,32}$/;
export const PASSWORD_MIN = 8;
